import type { SplitPage } from "@/utils/splitPages";

export interface PageAnchor {
  slideId: string;
  pageIndex: number;
}

export function anchorOf(page: SplitPage | undefined): PageAnchor | null {
  return page ? { slideId: page.slideId, pageIndex: page.pageIndex } : null;
}

export function indexForAnchor(pages: SplitPage[], anchor: PageAnchor): number {
  const first = pages.findIndex((p) => p.slideId === anchor.slideId);
  if (first < 0) return -1;
  const pageCount = pages[first].totalPagesForSlide || 1;
  return first + Math.min(Math.max(anchor.pageIndex, 0), pageCount - 1);
}

export function badgeTitleOf(page: SplitPage | undefined): string {
  if (!page) return "";
  return page.totalPagesForSlide > 1
    ? `${page.title} (${page.pageIndex + 1}/${page.totalPagesForSlide})`
    : page.title;
}

export function fallbackSplitPages(pages: any[]): SplitPage[] {
  return pages.map((p: any) => ({
    slideId: p.slideId || "",
    pageIndex: 0,
    totalPagesForSlide: 1,
    title: p.title || "",
    modules: p.modules || [],
    isOverflowPage: false,
  }));
}
